const initAddressCountryProvince = () => {
  window.Shopify = window.Shopify || {};

  window.Shopify.setSelectorByValue = (selector, value) => {
    for (let i = 0; i < selector.options.length; i++) {
      const option = selector.options[i];
      if (value === option.value || value === option.innerHTML) {
        selector.selectedIndex = i;
        return i;
      }
    }
    return 0;
  };

  window.Shopify.addListener = (target, eventName, callback) => {
    if (target.addEventListener) {
      target.addEventListener(eventName, callback, false);
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventName, callback);
    }
  };

  window.Shopify.bind =
    (fn, scope) =>
      (...args) =>
        fn.apply(scope, args);

  window.Shopify.CountryProvinceSelector = (countryDomId, provinceDomId, options = {}) => {
    const countryEl = document.getElementById(countryDomId);
    const provinceEl = document.getElementById(provinceDomId);
    const provinceContainer = document.getElementById(options.hideElement || provinceDomId);

    const clearOptions = (el) => {
      while (el.firstChild) el.removeChild(el.firstChild);
    };

    const countryHandler = () => {
      const selected = countryEl.options[countryEl.selectedIndex];
      const provinces = JSON.parse(selected.getAttribute('data-provinces') || '[]');

      clearOptions(provinceEl);

      if (!provinces.length) {
        provinceContainer.classList.add('hidden');
      } else {
        provinces.forEach(([val, label]) => {
          const opt = document.createElement('option');
          opt.value = val;
          opt.innerHTML = label;
          provinceEl.appendChild(opt);
        });
        provinceContainer.classList.remove('hidden');
      }
    };

    const initCountry = () => {
      const defaultVal = countryEl.getAttribute('data-default');
      window.Shopify.setSelectorByValue(countryEl, defaultVal);
      countryHandler();
    };

    const initProvince = () => {
      const defaultVal = provinceEl.getAttribute('data-default');
      if (defaultVal && provinceEl.options.length > 0) {
        window.Shopify.setSelectorByValue(provinceEl, defaultVal);
      }
    };

    window.Shopify.addListener(countryEl, 'change', () => countryHandler());
    initCountry();
    initProvince();
  };

  (() => {
    const countrySelects = document.querySelectorAll('[data-address-country-select]');
    if (window.Shopify.CountryProvinceSelector) {
      countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        if (formId) {
          window.Shopify.CountryProvinceSelector(`address-country-${formId}`, `address-province-${formId}`, {
            hideElement: `address-province-container-${formId}`,
          });
        }
      });
    }
  })();
};

export default initAddressCountryProvince;
